// App-local class merge helper for the shadcn primitives. Intentionally separate
// from cad-react's internal `cn` (boundary: the package's util is not part of its
// public surface). clsx for conditionals, tailwind-merge to dedupe conflicting
// Tailwind classes (last wins) so primitive defaults stay overridable by callers.
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
